<template>
    <div>
        <div class="detail-box">
            <img src="@/m/images/detail-bg.png" width="100%">
            <div class="detail-con">
                <div class="post-mesg">
                    <h2>{{detail.job_name}} <span>{{detail.salary}}</span></h2>
                    <span class="jobtype">{{detail.job_category}}</span>
                    <p class="info">招聘人数  {{detail.need_num}}<span>|</span>{{detail.edu}}</p>
                    <p class="place"><em v-for="(pla,num) in detail.place">{{pla}}<span v-if="num < detail.place.length - 1">|</span></em></p>
                    <p class="time">发布日期 {{detail.update_at}}</p>
                    <p class="jobskill">职位要求</p>
                    <p class="jobskill-c" v-html='detail.content'></p>
                    <p class="jobskill" v-if="detail.weal">福利</p>
                    <p class="jobskill-c"><em v-for="fu in detail.weal">{{fu}}  </em></p>
                    <yd-button size="large" type="primary" shape="circle" bgcolor="#369567" color="#fff" class="btn" @click.native="goto"  >投递简历</yd-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                detail:[]
            }
        },
        created() {
            this.getDetail();
        },
        watch: {
            //如果路由变化,执行id更新方法,获取详情
            '$route' : 'getDetail'
        },
        methods: {
            getDetail(){
                if(this.$route.name != 'sdetail') return;
                this.$axios
                    .get(this.api.getSocialDetail+'/'+this.$route.params.id)
                    .then( res  => {
                        if(res.code){
                            this.detail = res.data;
                        }else {
                            this.$Message.error(res.msg)
                        }
                    });
            },
            goto(){
                this.$router.push({ name: 'ssend', params: { id: this.detail.id}});
            }
        }

    }
</script>
<style scoped>
    img{
        display: block;
    }
    .detail-con{
        padding: 0 4% 10px 4%;
    }
    .post-mesg h2{
        font-size: .35rem;
        margin: 15px 0;
    }
    .post-mesg h2 span{
        color:#369567;
        float: right;
        font-weight: 100;
    }
    .jobtype{
        color: #909090;
        font-size: .24rem;
    }
    .info{
        color: #474747;
        font-size: .24rem;
        margin: 10px 0 0 0;
    }
    .info span{
        color: #d6d6d6;
        margin: 0 10px;
    }
    .place span{
        color: #d6d6d6;
        margin: 0 10px;
    }
    .time{
        font-size: .24rem;
        color: #474747;
    }
    .jobskill{
        color: #969696;
        font-size: .28rem;
        margin: 25px 0 10px 0;
    }
    .jobskill-c{
        font-size: .24rem;
        color: #222;
        margin: 5px 0;
    }
    .btn{
        width: 84%;
        margin: 40px 8% 20px 8%;
        font-family: '微软雅黑';
        font-size: .29rem;
        height: .85rem;
        box-shadow: 0px 10px 10px -10px  rgba(53, 147, 102, .8);
    }
</style>
